import Vue from "vue";
import * as BN from "bignumber.js";
import allabis, {
  infura_url,
  ERC20_abi,
  liquiditygauge_ABI,
  minter_ABI,
} from "./allabis";
import web3Init from "./init";
import * as common from "./utils/common.js";
import { poolMenus } from "./constants/poolMenus";
import {
  multicall_abi,
  multicall_address,
} from './constants/multicall'
import { config } from "./config";
import { contracts, geysers, minterAddress, snowAddress } from "./constants/contracts";

export const poolMenu = Vue.observable(poolMenus[config.network.shortName]);
const defaultContract = Object.keys(poolMenu)[0]

var N_COINS = contracts[defaultContract].N_COINS;
var coin_precisions = contracts[defaultContract].coin_precisions;
var old_swap_address = "0x2e60CF74d81ac34eB21eEff58Db4D385920ef419";
var swap_address = contracts[defaultContract].swap_address;
var token_address = contracts[defaultContract].token_address;
var old_token_address = "0x3740fb63ab7a09891d7c0d4299442A551D06F5fD";

export const LENDING_PRECISION = 1e18;
export const PRECISION = 1e18;
export const NOWRAP_POOLS = ["fusd", "crveth", "3pool", "yvault2", "yvault3", "usdsnow", "usdcsnow"];
export const DISABLED_FOR_DEPOSIT_POOLS = ["yvault2"];

var migration_address = "0x54Ee22d5593FC76fB20EafAb66C45aAb3268B800";

const currencies = {
  iearn: {
    dai: "yDAI",
    usdc: "yUSDC",
    usdt: "yUSDT",
    tusd: "yTUSD",
  },
  ethsnow: {
    wEth: "wEth",
    vEth2: "vEth2",
    aETHC: "aETHC",
    crETH2: "crETH2 ",
  },
  busd: {
    ycrv: "yUSD",
    bcrv: "ybCRV",
  },
  pusd: {
    YcrvRenWSBTC: "YcrvRenWSBTC",
    FcrvRenWBTC: "FcrvRenWBTC",
  },
  fusd: {
    usdc: "USDC",
    fusdc: "fUSDC",
    fusdt: "fUSDT",
    fdai: "fDAI",
  },
  '3pool': {
    dai: 'DAI',
    usdc: 'USDC',
    usdt: 'USDT'
  },
  crveth: {
    weth: "wETH",
    crvseth: "crvSETH",
    crvsteth: "crvStETH",
    crvankreth: "crvAnkrETH",
  },
  yvault2: {
    yvdai: 'yvDAI',
    yvusdc: 'yvUSDC',
    yvusdt: 'yvUSDT',
  },
  yvault3: {
    yvdai: 'yvDAI',
    yvusdc: 'yvUSDC',
    yvusdt: 'yvUSDT',
  },
  usdsnow: {
    dai: 'DAI',
    usdc: 'USDC',
    usdt: 'USDT',
  }
};

export const allCurrencies = currencies;

export const gas = {
  swap: {
    fusd: {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 1200000,
    },
    '3pool': {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 1200000,
    },
    crveth: {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 1200000,
    },
    iearn: {
      exchange: (i, j) => 1600000,
      exchange_underlying: (i, j) => 2000000,
    },
    yvault2: {
      exchange: (i, j) => 1600000,
      exchange_underlying: (i, j) => 2000000,
    },
    yvault3: {
      exchange: (i, j) => 1600000,
      exchange_underlying: (i, j) => 2000000,
    },
    usdsnow: {
      exchange: (i, j) => 1600000,
      exchange_underlying: (i, j) => 2000000,
    },
    ethsnow: {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 800000,
    },
    busd: {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 800000,
    },
    pusd: {
      exchange: (i, j) => 600000,
      exchange_underlying: (i, j) => 800000,
    },
  },
  deposit: {
    iearn: 1800000,
    ethsnow: 600000,
    fusd: 600000,
    '3pool': 600000,
    crveth: 600000,
    yvault2: 600000,
    yvault3: 600000,
    usdsnow: 600000,
    usdcsnow: 600000,
    busd: 600000,
    pusd: 600000,
  },
  withdraw: {
    iearn: {
      imbalance: (x) => Math.max(((12642 * x + 1074068) * 2.5) | 0, 1600000),
    },
    ethsnow: {
      imbalance: (x) => 600000,
    },
    busd: {
      imbalance: (x) => 600000,
    },
    fusd: {
      imbalance: (x) => 600000,
    },
    '3pool': {
      imbalance: (x) => 600000,
    },
    crveth: {
      imbalance: (x) => 600000,
    },
    yvault2: {
      imbalance: (x) => 600000,
    },
    yvault3: {
      imbalance: (x) => 600000,
    },
    usdsnow: {
      imbalance: (x) => 600000,
    },
    usdcsnow: {
      imbalance: (x) => 600000,
    },
    pusd: {
      imbalance: (x) => 600000,
    },
  },
  depositzap: {
    iearn: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, // original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    ethsnow: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, // original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    busd: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    fusd: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    '3pool': {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    crveth: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    yvault2: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    yvault3: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    usdsnow: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    usdcsnow: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
    pusd: {
      deposit: (x) => ((225377 * x + 522674) * 2.5) | 0, //original * 2
      withdraw: 3500000 / 1.1, //original value set at 1.4
      withdrawShare: 3500000,
      withdrawImbalance: (x) => ((276069 * x + 516861) * 2.5) | 0,
    },
  },
};

let initState = () => ({
  deposit_zap: null,
  balances: [],
  wallet_balances: [],
  underlying_coins: [],
  c_rates: [],
  bal_info: [],
  total: 0,
  l_info: [],
  totalShare: 0,
  showShares: false,
  totalSupply: 0,
  totalBalance: 0,
  usdShare: null,
  swapbtc: false,
  gaugeContract: null,
  minter: null,
  neededWrap: true,
  isDisabledDeposit: false,
});

const state = Vue.observable({
  web3: null,
  multicall: null,
  walletName: null,
  allInitContracts: new Set(),
  neededWrap: true,
  isDisabledDeposit: false,
  contracts: {
    iearn: {
      currentContract: "iearn",
      aRewards: null,
      ...initState(),
    },
    ethsnow: {
      currentContract: "ethsnow",
      ...initState(),
    },
    busd: {
      currentContract: "busd",
      ...initState(),
    },
    fusd: {
      currentContract: "fusd",
      ...initState(),
    },
    '3pool': {
      currentContract: "3pool",
      ...initState(),
    },
    crveth: {
      currentContract: "crveth",
      ...initState(),
    },
    yvault2: {
      currentContract: "yvault2",
      ...initState(),
    },
    yvault3: {
      currentContract: "yvault3",
      ...initState(),
    },
    usdsnow: {
      currentContract: "usdsnow",
      ...initState(),
    },
    usdcsnow: {
      currentContract: "usdcsnow",
      ...initState(),
    },
    pusd: {
      currentContract: "pusd",
      ...initState(),
    },
  },
  swapbtc: false,
  adapterContract: null,
  currentContract: defaultContract,
  currencies: currencies[defaultContract],
  N_COINS: N_COINS,
  coin_precisions: coin_precisions,
  wrapped_precisions: [],
  swap_address: swap_address,
  old_swap_address: old_swap_address,
  token_address: token_address,
  old_token_address: old_token_address,
  migration_address: migration_address,
  infura_url: infura_url,

  coins: new Array(N_COINS),
  underlying_coins: new Array(N_COINS),
  swap: null,
  old_swap: null,
  swap_token: null,
  old_swap_token: null,

  whitelist: null,

  totalBalance: null,
  totalSupply: null,
  oldBalance: null,

  ERC20Contract: null,
  balances: new Array(N_COINS),
  wallet_balances: new Array(N_COINS),
  fee: 0,
  admin_fee: 0,
  trade_timeout: 1800,
  max_allowance: BN(2).pow(BN(256)).minus(BN(1)),
  // coins: [],
  // underlying_coins: [],
  c_rates: [],
  bal_info: [],
  total: 0,
  l_info: [],
  totalShare: 0,
  showShares: false,

  staked_info: [],
  totalStake: -1,

  virtual_price: null,
  A: null,
  initial_A: null,
  initial_A_time: null,
  future_A: null,
  future_A_time: null,
  admin_actions_deadline: null,

  slippage: 0,
  showSlippage: false,
  showNoBalance: false,
  showNoBalanceCoin: "",

  initializedContracts: false,

  default_account: "",

  error: false,
  curveRewards: null,
  curveStakedBalance: null,

  usdShare: null,
  usdStake: null,

  curveRewards: null,
  snxExchanger: null,

  chi: null,

  aRewards: null,
});

export let contract = state;

export const getters = {
  default_account: () =>
    state.default_account || "0x0000000000000000000000000000000000000000",
  walletName: () => state.walletName,
  currentPool: () => state.currentContract,
  oldBalance: () => state.oldBalance,
  bal_info: () => state.bal_info,
  balTotal: () => state.total,
  l_info: () => state.l_info,
  totalShare: () => state.totalShare,
  totalBalance: () => state.totalBalance / 1e18,
  totalSupply: () => state.totalSupply / 1e18,
  currencies: () => state.currencies,
  fee: () => state.fee * 100,
  admin_fee: () => state.admin_fee * 100,
  A: () => state.A,
  initial_A: () => state.initial_A,
  initial_A_time: () => state.initial_A_time,
  future_A: () => state.future_A,
  future_A_time: () => state.future_A_time,
  admin_actions_deadline: () => state.admin_actions_deadline,
  initializedContracts: () => state.initializedContracts,
  showSlippage: () => state.showSlippage,
  slippage: () => state.slippage,
  N_COINS: () => state.N_COINS,
  error: () => state.error,
  showShares: () => state.showShares,
  neededWrap: () => state.neededWrap,
  staked_info: () => state.staked_info,
  totalStake: () => state.totalStake,

  usdShare: () => state.usdShare,
  usdStake: () => state.usdStake,
};

export async function init(contract, refresh = false) {
  state.neededWrap = !NOWRAP_POOLS.includes(state.currentContract);
  const disableDeposit = DISABLED_FOR_DEPOSIT_POOLS.includes(state.currentContract)
  state.isDisabledDeposit = disableDeposit
  state.multicall =
    state.multicall || new web3.eth.Contract(multicall_abi, multicall_address.address);
  console.time("init");
  if (
    state.initializedContracts &&
    contract.currentContract == state.currentContract &&
    !refresh
  )
    return Promise.resolve();
  if (
    contract &&
    (contract.currentContract == state.currentContract ||
      state.contracts[contract.currentContract].initializedContracts) &&
    !refresh
  )
    return Promise.resolve();
  if (!contract) {
    contract = state;
  }
  try {
    let networkId = await state.web3.eth.net.getId();
    // TODO: make an env trigger for HARDHAT
    // if (networkId != 1) {
    //   this.error = "Error: wrong network type. Please switch to mainnet";
    // }
  } catch (err) {
    console.error(err);
    this.error = "There was an error connecting. Please refresh page";
  }

  contract.gaugeContract = new state.web3.eth.Contract(
    liquiditygauge_ABI,
    contracts[contract.currentContract].gauge_address
  );

  Object.entries(geysers).forEach(([name, geyser]) => {
    contract[name] = new state.web3.eth.Contract(
      geyser.abi,
      geyser.address
    )
  })

  contract.votingToken = new state.web3.eth.Contract(ERC20_abi, snowAddress.address);

  let calls = [
    //get_virtual_price
    [contracts[contract.currentContract].swap_address, "0xbb7b8b80"],
    //A
    [contracts[contract.currentContract].swap_address, "0xf446c1d0"],
    //future_A
    [contracts[contract.currentContract].swap_address, "0xb4b577ad"],
    //admin_actions_deadline
    [contracts[contract.currentContract].swap_address, "0x405e28f8"],
  ];

  if (["iearn", "y"].includes(contract.currentContract) && config.network.shortName === 'eth') {
    contract.minter = new state.web3.eth.Contract(minter_ABI, minterAddress.address);

    contract.aRewards = new state.web3.eth.Contract(
      allabis.iearn.aRewards_abi,
      allabis.iearn.aRewards_address
    );
    contract.curveRewards = new state.web3.eth.Contract(
      allabis.iearn.sCurveRewards_abi,
      allabis.iearn.sCurveRewards_address
    );
    // window[contract.currentContract].rewards = contract.curveRewards;
    // window[contract.currentContract].aRewards = contract.aRewards;
    //calls.push([contract.curveRewards._address, contract.curveRewards.methods.balanceOf(state.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])
  }

  console.log(contract.gaugeContract._address, contract.gaugeContract.methods)

  calls.push([
    contract.gaugeContract._address,
    contract.gaugeContract.methods
      .balanceOf(
        state.default_account || "0x0000000000000000000000000000000000000000"
      )
      .encodeABI(),
  ]);

  if (
    ![
      "susd",
      "tbtc",
      "ren",
      "sbtc",
      "hbtc",
      "fusd",
      "crveth",
      "3pool",
      "yvault2",
      "yvault3",
      "usdsnow",
      "usdcsnow",
    ].includes(
      contract.currentContract
    )
  ) {
    state.deposit_zap = new state.web3.eth.Contract(
      contracts[state.currentContract].deposit_abi,
      contracts[state.currentContract].deposit_address
    );
  }

  contract.swap = new state.web3.eth.Contract(
    contracts[contract.currentContract].swap_abi,
    contracts[contract.currentContract].swap_address
  );

  contract.swap_token = new state.web3.eth.Contract(
    ERC20_abi,
    contracts[contract.currentContract].token_address
  );

  if (contracts[contract.currentContract].whitelist_address) {
    contract.whitelist = new state.web3.eth.Contract(
      contracts[contract.currentContract].whitelist_abi,
      contracts[contract.currentContract].whitelist_address
    )
  } else {
    contract.whitelist = null
  }

  window[contract.currentContract] = {};
  window[contract.currentContract].swap = contract.swap;
  window[contract.currentContract].swap_token = contract.swap_token;
  window[contract.currentContract].whitelist = contract.whitelist
  window[contract.currentContract].isDisabledDeposit = contract.isDisabledDeposit

  Object.keys(geysers).forEach((key) => {
    window[contract.currentContract][key] = contract[key]
  })

  window[contract.currentContract].votingToken = contract.votingToken;
  window[contract.currentContract].deposit_zap = contract.deposit_zap;

  contract.coins = [];
  contract.underlying_coins = [];

  if (window.location.href.includes("withdraw_old")) {
    calls.push(...(await common.update_fee_info("old", contract, false)));
  } else {
    calls.push(...(await common.update_fee_info("new", contract, false)));
  }

  for (let i = 0; i < contracts[contract.currentContract].N_COINS; i++) {
    let coinsCall = contract.swap.methods.coins(i).encodeABI();

    let noNeedWrap = [
      "tbtc",
      "ren",
      "sbtc",
      "hbtc",
      "ethsnow",
      "fusd",
      "crveth",
      "3pool",
      "yvault2",
      "yvault3",
      "usdsnow",
      "usdcsnow",
    ].includes(contract.currentContract);

    let underlyingCoinsCall = noNeedWrap
      ? contract.swap.methods.coins(i).encodeABI()
      : contract.swap.methods.underlying_coins(i).encodeABI();
    calls.push([contract.swap._address, coinsCall]);
    calls.push([contract.swap._address, underlyingCoinsCall]);
  }

  await common.multiInitState(calls, contract, true);
  contract.initializedContracts = true;
  console.timeEnd("init");
  state.allInitContracts = new Set(
    state.allInitContracts.add(contract.currentContract)
  );
  console.log([...state.allInitContracts]);
}

export const allState = Vue.observable({
  swap: {},
  underlying_coins: {},
});

export async function getAllUnderlying() {
  for ([key, contract] of Object.entries(contracts)) {
    if (key == "susd") continue;
    allState.swap[key] = new state.web3.eth.Contract(
      contract.swap_abi,
      contract.swap_address
    );
    allState.underlying_coins[key] = [];
    for (let i = 0; i < contract.N_COINS; i++) {
      var addr = await allState.swap[key].methods.coins(i).call();
      var underlying_addr = await allState.swap[key].swap.methods
        .underlying_coins(i)
        .call();
      allState.underlying_coins[key][i] = new state.web3.eth.Contract(
        ERC20_abi,
        underlying_addr
      );
    }
  }
}

export async function changeContract(pool) {
  //re-init contract with different pool
  if (!(pool in contracts)) return;
  state.initializedContracts = false;
  state.currentContract = pool;
  state.currencies = currencies[pool];
  state.N_COINS = contracts[pool].N_COINS;
  state.coin_precisions = contracts[pool].coin_precisions;
  state.wrapped_precisions = contracts[pool].wrapped_precisions;
  state.swap_address = contracts[pool].swap_address;
  state.old_swap_address = contracts[pool].old_swap_address;
  state.token_address = contracts[pool].token_address;
  state.old_token_address = contracts[pool].old_token_address;
  state.migration_address = contracts[pool].migration_address;
  state.coins = new Array(contracts[pool].coins);
  state.underlying_coins = new Array(contracts[pool].underlying_coins);
  state.balances = new Array(contracts[pool].balances);
  state.wallet_balances = new Array(contracts[pool].wallet_balances);
  state.bal_info = [];
  state.l_info = [];
  state.total = 0;
  state.totalShare = 0;
  state.neededWrap = NOWRAP_POOLS.includes(pool);
  await web3Init();
}

export function setCurrencies(pool) {
  contract.currencies = currencies[pool];
}

export async function initusdt() {
  await init(state.contracts.usdt);
}
